const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const attributionKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];

function filterAttribution(attribution) {
  const result = {};
  for (const key of attributionKeys) {
    const value = attribution?.[key];
    if (typeof value !== 'string') continue;
    const normalized = value.trim().toLowerCase();
    if (normalized.length >= 1 && normalized.length <= 64 && /^[a-z0-9._-]+$/.test(normalized)) {
      result[key] = normalized;
    }
  }
  return result;
}

export function readAttribution(search) {
  const params = new URLSearchParams(search);
  return filterAttribution(Object.fromEntries(attributionKeys.map((key) => [key, params.get(key)])));
}

export function normalizeEmail(value) {
  return value.trim().toLowerCase();
}

export function validateSubmission({ email, consent, website }) {
  if (website.trim()) return { kind: 'bot' };
  const normalized = normalizeEmail(email);
  if (!emailPattern.test(normalized)) return { kind: 'invalid-email' };
  if (!consent) return { kind: 'missing-consent' };
  return { kind: 'valid', email: normalized };
}

export async function submitWaitlist({ email, attribution = {}, endpoint, anonKey, fetchImpl = fetch }) {
  if (!endpoint || !anonKey) {
    throw new Error('Die Warteliste ist gerade nicht verfügbar.');
  }

  const validatedAttribution = filterAttribution(attribution);
  const payload = { email, source: 'landing' };
  const send = (body) => fetchImpl(`${endpoint.replace(/\/$/, '')}/rest/v1/waitlist`, {
    method: 'POST',
    headers: {
      apikey: anonKey,
      Authorization: `Bearer ${anonKey}`,
      'Content-Type': 'application/json',
      Prefer: 'return=minimal',
    },
    body: JSON.stringify(body),
  });

  let response = await send({ ...payload, ...validatedAttribution });
  if (response.status === 400 && Object.keys(validatedAttribution).length > 0) {
    response = await send(payload);
  }

  if (response.ok) return 'created';
  if (response.status === 409) return 'duplicate';
  throw new Error('Das hat nicht geklappt. Bitte versuche es erneut.');
}
